// extracted by mini-css-extract-plugin
export default {"showEdit":"styles-module__showEdit__src-labstep-web-components-Experiment-Form-ShowEdit-Name-_dyWBe"};